import { Deserializable, Deserialize } from "../helpers/serialization";
import { TextProperties } from "./text-properties";

export class CanvasRenderer
{
    public ctx:CanvasRenderingContext2D;
    private width:number;
    private height:number;
    private canvas:HTMLCanvasElement;

    private defaultText:TextProperties;

    constructor (canvas:HTMLCanvasElement)
    {
        this.defaultText = new TextProperties();
        this.canvas = canvas;
        this.ctx = canvas.getContext("2d");
    }

    clear(color:string = "")
    {
        if (color != "")
        {
            this.ctx.fillStyle = color;
            this.ctx.setTransform(1,0,0,1,0.5,0.5);
            this.ctx.fillRect(0,0, this.width, this.height);      
        }
        else
        {
            this.ctx.clearRect(0,0,this.width,this.height);
        }
    }

    resize(width:number, height:number)
    {
        this.width = width;
        this.height = height;
        this.canvas.width = width;
        this.canvas.height = height;
        this.ctx.textAlign = "center";                 
        this.ctx.textBaseline = "middle";            
    }

    text(x:number, y:number, str:string, params?:any)
    {
        let settings:TextProperties = this.defaultText;

        if (params instanceof TextProperties)
            settings = params;
        else if (params != null)
            settings = TextProperties.FromObject(params);

        let fillStyle = this.ctx.fillStyle;            

        this.ctx.fillStyle = settings.color.ToRGBA();        
        this.ctx.font = settings.css();
        this.ctx.fillText(str, x, y);
        this.ctx.fillStyle = fillStyle;
    }

    textCell(row:number, col:number, str:string, params?:any)
    {
        // not supported
    }

    dot(x:number, y:number)
    {
        this.ctx.fillRect(x-2, y-2, 4, 4);
    }

    image(img:HTMLImageElement, x:number = 0, y:number = 0, w?:number, h?:number)
    {
        if (typeof w == "undefined") w = img.width;
        if (typeof h == "undefined") h = img.height;
        this.ctx.drawImage(img, x, y, w, h);
    }
}